// ══════════════════════════════════════
// SVG ICONS (inline, no emoji)
// ══════════════════════════════════════

const ICONS = {
  seedling: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M7 20h10M12 20v-8m0 0c0-4 3-7 7-7-1 4-3 7-7 7zm0 0c0-4-3-7-7-7 1 4 3 7 7 7z"/></svg>`,
  heart: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>`,
  zap: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>`,
  star: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>`,
  sparkles: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3l1.5 4.5L18 9l-4.5 1.5L12 15l-1.5-4.5L6 9l4.5-1.5L12 3zM5 18l.5 1.5L7 20l-1.5.5L5 22l-.5-1.5L3 20l1.5-.5L5 18zM19 14l.5 1.5L21 16l-1.5.5L19 18l-.5-1.5L17 16l1.5-.5L19 14z"/></svg>`,
  target: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="6"/><circle cx="12" cy="12" r="2"/></svg>`,
  clock: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>`,
  shield: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>`,
  eye: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>`,
  box: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></svg>`,
  thumbsUp: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3"/></svg>`,
  dollar: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>`,
  calendar: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>`,
  palette: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="13.5" cy="6.5" r="0.5" fill="currentColor"/><circle cx="17.5" cy="10.5" r="0.5" fill="currentColor"/><circle cx="8.5" cy="7.5" r="0.5" fill="currentColor"/><circle cx="6.5" cy="12.5" r="0.5" fill="currentColor"/><path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.926 0 1.648-.746 1.648-1.688 0-.437-.18-.835-.437-1.125-.29-.289-.438-.652-.438-1.125a1.64 1.64 0 0 1 1.668-1.668h1.996c3.051 0 5.555-2.503 5.555-5.555C21.965 6.012 17.461 2 12 2z"/></svg>`,
  droplet: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0z"/></svg>`,
  scissors: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="6" cy="6" r="3"/><circle cx="6" cy="18" r="3"/><line x1="20" y1="4" x2="8.12" y2="15.88"/><line x1="14.47" y1="14.48" x2="20" y2="20"/><line x1="8.12" y1="8.12" x2="12" y2="12"/></svg>`,
  feather: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20.24 12.24a6 6 0 0 0-8.49-8.49L5 10.5V19h8.5z"/><line x1="16" y1="8" x2="2" y2="22"/><line x1="17.5" y1="15" x2="9" y2="15"/></svg>`,
  ruler: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M16 4h2a2 2 0 0 1 2 2v1m0 4v2m0 4v1a2 2 0 0 1-2 2h-2M8 20H6a2 2 0 0 1-2-2v-1m0-4v-2m0-4V6a2 2 0 0 1 2-2h2"/></svg>`,
  camera: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/><circle cx="12" cy="13" r="4"/></svg>`,
  arrowUp: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="19" x2="12" y2="5"/><polyline points="5 12 12 5 19 12"/></svg>`,
  lock: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>`,
  leaf: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M17 8C8 10 5.9 16.17 3.82 21.34L5.71 22l1-2.3A4.49 4.49 0 0 0 8 20c4 0 8.68-2.37 9-8 .03-.64.1-1.43.2-2.2.17-1.24.47-2.8.8-3.8z"/><path d="M2 2s7.4-2 13 3.2"/></svg>`,
  tool: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/></svg>`,
  noEntry: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="4.93" y1="4.93" x2="19.07" y2="19.07"/></svg>`,
  mascaraBottle: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="8" y="15" width="8" height="7" rx="1"/><rect x="9.5" y="12" width="5" height="3"/><line x1="12" y1="12" x2="12" y2="3"/><line x1="12" y1="4" x2="9.5" y2="5"/><line x1="12" y1="6" x2="9" y2="7"/><line x1="12" y1="8" x2="9.5" y2="9"/><line x1="12" y1="10" x2="10.5" y2="11"/><line x1="12" y1="4" x2="14.5" y2="5"/><line x1="12" y1="6" x2="15" y2="7"/><line x1="12" y1="8" x2="14.5" y2="9"/><line x1="12" y1="10" x2="13.5" y2="11"/></svg>`,
  stripLash: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M2 18 Q12 14 22 18"/><line x1="4.5" y1="17.5" x2="4" y2="11"/><line x1="8" y1="16.5" x2="7" y2="8.5"/><line x1="11.5" y1="15.5" x2="10" y2="6"/><line x1="15" y1="15.5" x2="16.5" y2="6"/><line x1="18.5" y1="16.5" x2="19.5" y2="8.5"/></svg>`,
  tweezers: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><line x1="9" y1="3" x2="11.5" y2="20"/><line x1="15" y1="3" x2="12.5" y2="20"/><line x1="9" y1="3" x2="15" y2="3"/></svg>`,
  calendar10: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/><text x="12" y="18" font-family="Avenir Next,sans-serif" font-size="7" font-weight="700" fill="currentColor" stroke="none" text-anchor="middle">10+</text></svg>`,
  calendar5: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/><text x="12" y="18.5" font-family="Avenir Next,sans-serif" font-size="9" font-weight="700" fill="currentColor" stroke="none" text-anchor="middle">5</text></svg>`,
  lashHairShort: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M3 19 Q12 15 21 19"/><line x1="7" y1="17" x2="5" y2="14"/><line x1="10" y1="15.5" x2="9" y2="10" stroke-opacity="0.45"/><line x1="14" y1="15.5" x2="15.5" y2="7" stroke-opacity="0.45"/><line x1="17" y1="17" x2="21" y2="5" stroke-opacity="0.45"/></svg>`,
  lashHairMedium: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M3 19 Q12 15 21 19"/><line x1="7" y1="17" x2="5" y2="14" stroke-opacity="0.45"/><line x1="10" y1="15.5" x2="9" y2="10"/><line x1="14" y1="15.5" x2="15.5" y2="7" stroke-opacity="0.45"/><line x1="17" y1="17" x2="21" y2="5" stroke-opacity="0.45"/></svg>`,
  lashHairLong: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M3 19 Q12 15 21 19"/><line x1="7" y1="17" x2="5" y2="14" stroke-opacity="0.45"/><line x1="10" y1="15.5" x2="9" y2="10" stroke-opacity="0.45"/><line x1="14" y1="15.5" x2="15.5" y2="7"/><line x1="17" y1="17" x2="21" y2="5" stroke-opacity="0.45"/></svg>`,
  lashHairXL: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M3 19 Q12 15 21 19"/><line x1="7" y1="17" x2="5" y2="14" stroke-opacity="0.45"/><line x1="10" y1="15.5" x2="9" y2="10" stroke-opacity="0.45"/><line x1="14" y1="15.5" x2="15.5" y2="7" stroke-opacity="0.45"/><line x1="17" y1="17" x2="21" y2="5"/></svg>`,
  shapeWispy: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M2 18 Q12 16 22 18"/><line x1="5" y1="17.7" x2="5" y2="12"/><line x1="8" y1="17" x2="8" y2="5"/><line x1="11" y1="16.5" x2="11" y2="9"/><line x1="14" y1="16.3" x2="14" y2="4"/><line x1="17" y1="16.8" x2="17" y2="10"/><line x1="20" y1="17.5" x2="20" y2="13"/></svg>`,
  shapeEven: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M2 18 Q12 16 22 18"/><line x1="5" y1="17.7" x2="5" y2="7"/><line x1="8.5" y1="17" x2="8.5" y2="6"/><line x1="12" y1="16.6" x2="12" y2="5.5"/><line x1="15.5" y1="17" x2="15.5" y2="6"/><line x1="19" y1="17.7" x2="19" y2="7"/></svg>`,
  shapeCatEye: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M2 18 Q12 16 22 18"/><line x1="5" y1="17.7" x2="5" y2="14"/><line x1="8" y1="17" x2="8" y2="11"/><line x1="11" y1="16.5" x2="11" y2="8"/><line x1="14" y1="16.3" x2="14" y2="5"/><line x1="17" y1="16.8" x2="17" y2="3"/><line x1="20" y1="17.5" x2="20" y2="2"/></svg>`,
  mascaraBottleBand: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="8" y="15" width="8" height="7" rx="1"/><rect x="9.5" y="12" width="5" height="3"/><line x1="12" y1="12" x2="12" y2="3"/><line x1="12" y1="4" x2="9.5" y2="5"/><line x1="12" y1="6" x2="9" y2="7"/><line x1="12" y1="8" x2="9.5" y2="9"/><line x1="12" y1="10" x2="10.5" y2="11"/><line x1="12" y1="4" x2="14.5" y2="5"/><line x1="12" y1="6" x2="15" y2="7"/><line x1="12" y1="8" x2="14.5" y2="9"/><line x1="12" y1="10" x2="13.5" y2="11"/><line x1="8" y1="17.75" x2="16" y2="17.75"/><line x1="8" y1="19.5" x2="16" y2="19.5"/></svg>`,
  bubbles: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="14" r="5"/><circle cx="16.5" cy="10" r="3.5"/><circle cx="15" cy="17.5" r="2.5"/><circle cx="6" cy="7.5" r="2"/></svg>`,
};

// ══════════════════════════════════════
// SHOPIFY PRODUCT DATA
// ══════════════════════════════════════

const VARIANT_IDS = {
  "Classic Luxe Wispy No. 15": 46110271537396,
  "Classic No. 01": 45849865617652,
  "Classic Shorties No. 05": 45849876234484,
  "Volume No. 02": 45849867911412,
  "Volume Luxe XL No. 12": 46110784487668,
  "Volume Shorties No. 06": 45849878921460,
  "Mega No. 03": 46110403231988,
  "Original": 47861615493364,
  "Original Shorties": 47861615460596,
  "Wispy": 47861615526132,
  "Full": 47861615591668,
  "Max": 47861615558900,
};

// Step illustrations (shared across all experience branches) — sourced from prolash.com/pages/how-to.
const STEP_IMAGES = [
  "https://prolash.com/cdn/shop/files/application_steps-06.png?v=1775511757",
  "https://prolash.com/cdn/shop/files/application_steps-07.png?v=1775511756",
  "https://prolash.com/cdn/shop/files/application_steps-08.png?v=1775511756"
];

// Essentials (5-day) variant box colors — used to theme the results page per variant.
const ESSENTIALS_VARIANT_COLORS = {
  "Original Shorties": "#6E1532",
  "Original": "#E5AACD",
  "Wispy": "#E7D770",
  "Full": "#5D88BC",
  "Max": "#CF282B"
};

const KITS = {
  "10day": {
    title: "The Starter Kit",
    price: "$85.00",
    img: "https://cdn.shopify.com/s/files/1/0619/3437/1060/files/Classic-01_starter-kit_1080x1080_7d7cbaa8-e92e-4836-81da-ec33e455540e.jpg?v=1775484777",
    blurb: "A month of lashes, adhesive, tweezers, and remover. Everything included.",
    valueLine: "One box. 30 days of wear.",
    variants: {
      "Classic No. 01": 46781347856628,
      "Classic Shorties No. 05": 46781347954932,
      "Classic Luxe Wispy No. 15": 46781348053236,
      "Volume No. 02": 46781349331188,
      "Volume Shorties No. 06": 46781349527796,
      "Volume Luxe XL No. 12": 46781349593332,
      "Mega No. 03": 46781349429492,
    }
  },
  "5day": {
    title: "Essentials Complete Kit",
    price: "$35.00",
    img: "https://cdn.shopify.com/s/files/1/0619/3437/1060/files/Original_Shortie-1_6885bc3c-3300-410e-8470-b34485882662.png?v=1775515258",
    blurb: "Lashes, bond, and tweezers in one box. Everything you need for up to 5 days of wear, nothing you don't.",
    valueLine: "One box. Everything included.",
    variants: {
      "Original Shorties": 47861615460596,
      "Original": 47861615493364,
      "Full": 47861615591668,
      "Wispy": 47861615526132,
      "Max": 47861615558900,
    }
  }
};

function onShopifyDomain() {
  return /(^|\.)prolash\.com$/.test(location.hostname) || /\.myshopify\.com$/.test(location.hostname);
}

function cartPermalink(variantId, qty) {
  return 'https://prolash.com/cart/' + variantId + ':' + (qty || 1) + (window.__emailCaptured ? '?discount=' + DISCOUNT_CODE : '');
}

function addToCart(variantId, qty) {
  var s = window.__quizState || {};
  track('quiz_cta_click', { variant_id: String(variantId), top_match: s.topMatch, wear_time: s.wearTime });
  if (!onShopifyDomain()) {
    window.location.href = cartPermalink(variantId, qty);
    return;
  }
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: [{ id: variantId, quantity: qty || 1 }] })
  }).then(r => { if (!r.ok) throw new Error('add failed'); return r.json(); })
    .then(() => {
      window.location.href = window.__emailCaptured ? '/discount/' + DISCOUNT_CODE + '?redirect=/cart' : '/cart';
    })
    .catch(err => console.error('Add to cart error:', err));
}

const PRODUCT_IMAGES = {
  "Classic Luxe Wispy No. 15": "https://cdn.shopify.com/s/files/1/0619/3437/1060/files/beforeArtboard28copy3.jpg?v=1762197937",
  "Classic No. 01": "https://cdn.shopify.com/s/files/1/0619/3437/1060/files/1Artboard1copy9_4f866370-b07f-40cc-a942-07b49a7ff56a.jpg?v=1772535692",
  "Classic Shorties No. 05": "https://cdn.shopify.com/s/files/1/0619/3437/1060/files/Classic-Shorties-05.png?v=1771935599",
  "Volume No. 02": "https://cdn.shopify.com/s/files/1/0619/3437/1060/files/1Artboard1copy10.jpg?v=1771935599",
  "Volume Luxe XL No. 12": "https://cdn.shopify.com/s/files/1/0619/3437/1060/files/Volume-Luxe-XL-12.png?v=1771935599",
  "Volume Shorties No. 06": "https://cdn.shopify.com/s/files/1/0619/3437/1060/files/Volume-Shorties-06.png?v=1771935599",
  "Mega No. 03": "https://cdn.shopify.com/s/files/1/0619/3437/1060/files/Mega-Volume-03.png?v=1772538524",
  "Original": "https://cdn.shopify.com/s/files/1/0619/3437/1060/files/Original-1_f4818298-6bf4-4a1f-99ec-f6696b44187d.png?v=1775515258",
  "Original Shorties": "https://cdn.shopify.com/s/files/1/0619/3437/1060/files/Original_Shortie-1_6885bc3c-3300-410e-8470-b34485882662.png?v=1775515258",
  "Wispy": "https://cdn.shopify.com/s/files/1/0619/3437/1060/files/Wispy-1_aea4c896-d94a-43b3-945f-2d1cf56e5353.png?v=1775515258",
  "Full": "https://cdn.shopify.com/s/files/1/0619/3437/1060/files/full-1_c7284f1f-9565-4aa6-b803-1714f57f6161.png?v=1775515258",
  "Max": "https://cdn.shopify.com/s/files/1/0619/3437/1060/files/max-1_ed48ae42-6e43-4723-a0eb-6e3ea2c2b4d7.png?v=1775515258",
};

const LASH_CURVES = {
  "Classic Luxe Wispy No. 15": "https://cdn.shopify.com/s/files/1/0619/3437/1060/files/LASH_CURVE-12.png?v=1774034279",
  "Classic No. 01": "https://cdn.shopify.com/s/files/1/0619/3437/1060/files/LASH_CURVE-02.png?v=1774033787",
  "Classic Shorties No. 05": "https://cdn.shopify.com/s/files/1/0619/3437/1060/files/LASH_CURVE-05.png?v=1774034040",
  "Volume No. 02": "https://cdn.shopify.com/s/files/1/0619/3437/1060/files/LASH_CURVE-03.png?v=1774033858",
  "Volume Luxe XL No. 12": "https://cdn.shopify.com/s/files/1/0619/3437/1060/files/LASH_CURVE-11.png?v=1774034219",
  "Volume Shorties No. 06": "https://cdn.shopify.com/s/files/1/0619/3437/1060/files/LASH_CURVE-06.png?v=1774034082",
  "Mega No. 03": "https://cdn.shopify.com/s/files/1/0619/3437/1060/files/LASH_CURVE-04.png?v=1774033944",
  "Original": "https://cdn.shopify.com/s/files/1/0619/3437/1060/files/original-4.jpg?v=1775515258",
  "Original Shorties": "https://cdn.shopify.com/s/files/1/0619/3437/1060/files/original_shortie-4.jpg?v=1775515258",
  "Wispy": "https://cdn.shopify.com/s/files/1/0619/3437/1060/files/wispy-4.jpg?v=1775515258",
  "Full": "https://cdn.shopify.com/s/files/1/0619/3437/1060/files/full-4.jpg?v=1775515258",
  "Max": "https://cdn.shopify.com/s/files/1/0619/3437/1060/files/max-4.jpg?v=1775515258",
};

const DATA = {
  experience: {
    never: {
      label: "First-Timer", icon: "sparkles", tagline: "Welcome to the lash game",
      heroNudge: "This is your first time and we're going to make it easy. No overwhelm, just results.",
      summary: "You've never tried lash extensions before, and that's totally fine. We picked the most beginner-friendly kit with everything you need to get salon-worthy results on your very first try.",
      whyCards: [
        { icon: "target", title: "Beginner-Proof", text: "These styles are specifically designed for first-timers. Forgiving placement, easy application, stunning results even if your hands are a little shaky." },
        { icon: "box", title: "Everything Included", text: "No guessing what you need. Your kit comes with lashes, adhesive, tweezers, and a step-by-step guide. Open and go." },
        { icon: "thumbsUp", title: "Confidence Builder", text: "Start here and you'll wonder why you waited. Most first-timers nail it by their second application." }
      ],
      steps: [
        { title: "Apply Adhesive", text: "Apply adhesive to the base of your natural lashes. Two to three coats." },
        { title: "Apply Lashes", text: "Place each lash segment underneath your natural lashes, inner corner out." },
        { title: "Crimp & Wear", text: "When everything feels perfect, crimp your natural lashes and Pro Lash together with your tweezers." }
      ],
      callout: "<strong>First-timer tip:</strong> Don't stress about perfection on your first try. It takes about 15 minutes the first time, but by your 3rd application you'll be down to 5-7 minutes. The results are worth the learning curve!"
    },
    mascara: {
      label: "Mascara Lover", icon: "mascaraBottle", tagline: "Ready for the upgrade",
      heroNudge: "You love the look mascara gives you. Now imagine that look, but you wake up with it for 10 days straight.",
      summary: "You already know you love defined lashes. Pro Lash gives you that same 'my lashes but better' effect without daily application, smudging, or raccoon eyes by 3pm.",
      whyCards: [
        { icon: "clock", title: "Skip the Daily Routine", text: "No more morning mascara, no more evening removal. Apply once, look amazing for days. That's 10-15 minutes back every single morning." },
        { icon: "noEntry", title: "No More Smudging", text: "Rain, sweat, tears, naps. Your lashes stay perfect through all of it. No more checking under your eyes at lunch." },
        { icon: "sparkles", title: "Better Than Mascara", text: "More dimension, more length, more definition than even the best mascara can deliver. And it looks completely natural." }
      ],
      steps: [
        { title: "Apply Adhesive", text: "Apply adhesive to the base of your natural lashes. Two to three coats." },
        { title: "Apply Lashes", text: "Place each lash segment underneath your natural lashes, inner corner out." },
        { title: "Crimp & Wear", text: "When everything feels perfect, crimp your natural lashes and Pro Lash together with your tweezers." }
      ],
      callout: "<strong>Coming from mascara:</strong> The biggest difference you'll notice is waking up with perfect lashes. No morning routine, no end-of-day raccoon eyes. Most mascara lovers say they can never go back."
    },
    strips: {
      label: "Strip Lash User", icon: "stripLash", tagline: "Goodbye strips, hello upgrade",
      heroNudge: "You know the lash game. Now ditch the daily glue-and-pray routine for something that actually lasts.",
      summary: "You already know how to handle lashes. Pro Lash is everything you love about strips minus the daily application, the peeling corners, the glue mess, and the 'are these falling off?' anxiety.",
      whyCards: [
        { icon: "calendar", title: "Apply Once, Wear for Days", text: "Instead of gluing strips on every morning and peeling them off every night, you apply once and look perfect for {daysLine} straight." },
        { icon: "eye", title: "Way More Natural", text: "Individual segments blend seamlessly with your natural lashes. No bulky strip look. People will think they're yours." },
        { icon: "shield", title: "Waterproof & Secure", text: "No peeling corners, no lash emergencies. Swim, shower, sweat through your workout. They stay put until you decide to remove them." }
      ],
      steps: [
        { title: "Apply Adhesive", text: "Apply adhesive to the base of your natural lashes. Two to three coats." },
        { title: "Apply Lashes", text: "Place each lash segment underneath your natural lashes, inner corner out." },
        { title: "Crimp & Wear", text: "When everything feels perfect, crimp your natural lashes and Pro Lash together with your tweezers." }
      ],
      callout: "<strong>Coming from strips:</strong> The application technique is similar enough that you'll pick it up instantly, but different enough that it feels way more natural. The segments follow your actual lash line instead of sitting as one rigid band."
    },
    extensions: {
      label: "Extensions Convert", icon: "tweezers", tagline: "Salon results, your schedule",
      heroNudge: "Same gorgeous lash look you love from the salon. But you control the schedule, the cost, and the style.",
      summary: "You already know what great lashes look like. Pro Lash delivers that same salon-quality result at a fraction of the cost, without the 2-hour appointments, the fills, or the $200+ bills.",
      whyCards: [
        { icon: "dollar", title: "Save $200+/Month", text: "Professional extensions cost $150-300 for a full set plus $75-150 for fills. Pro Lash delivers the same look for a fraction of the cost." },
        { icon: "calendar", title: "No Appointments", text: "No more scheduling fills around your life. Apply on your couch, on your timeline. 10 minutes beats a salon chair any day." },
        { icon: "palette", title: "Switch Styles Anytime", text: "Want natural Monday and glam Friday? Swap styles whenever you want. No commitment to one look for 3 weeks." }
      ],
      steps: [
        { title: "Apply Adhesive", text: "Apply adhesive to the base of your natural lashes. Two to three coats." },
        { title: "Apply Lashes", text: "Place each lash segment underneath your natural lashes, inner corner out." },
        { title: "Crimp & Wear", text: "When everything feels perfect, crimp your natural lashes and Pro Lash together with your tweezers." }
      ],
      callout: "<strong>Coming from salon extensions:</strong> The look is comparable. The cost is 80% less. The time commitment is 90% less. Most extension converts say their lash tech couldn't tell the difference."
    }
  },

  wearTime: {
    "10day": {
      label: "10+ Day Wear", tag: "PROWEAR", icon: "calendar10", line: "ProWear", daysLine: "up to 10+ days",
      description: "Maximum longevity. Apply once, look amazing for 10+ days. Our strongest bond formula.",
      kitItems: [
        { icon: "sparkles", name: "Lashes", desc: "Your matched style in ProWear" },
        { icon: "droplet", name: "Pro Lock Adhesive", desc: "10-day bond formula, 4.5ml" },
        { icon: "tool", name: "Tweezers", desc: "Precision placement & crimping" },
        { icon: "droplet", name: "Remover", desc: "Gentle, oil-based removal" }
      ]
    },
    "5day": {
      label: "Up to 5-Day Wear", tag: "ESSENTIALS", icon: "calendar5", line: "Essentials", daysLine: "up to 5 days",
      description: "Perfect for trying different looks or shorter commitments. Easy on, easy off.",
      kitItems: [
        { icon: "stripLash", name: "Lash Segments", desc: "Your matched Essentials style" },
        { icon: "mascaraBottleBand", name: "Pro Lock Adhesive", desc: "5-day wear adhesive" },
        { icon: "tweezers", name: "Tweezers", desc: "Easy-grip placement tweezers" }
      ]
    }
  },

  lengths: {
    short: { label: "Short", icon: "lashHairShort", vibe: "subtle everyday enhancement" },
    medium: { label: "Medium", icon: "lashHairMedium", vibe: "polished and put-together" },
    long: { label: "Long", icon: "lashHairLong", vibe: "defined and confident" },
    "extra-long": { label: "Extra Long", icon: "lashHairXL", vibe: "full drama, main character energy" }
  },

  shapes: {
    wispy: {
      label: "Wispy & Feathered", icon: "shapeWispy", vibe: "effortlessly textured",
      desc: "Wispy lashes have varied lengths for a soft, feathered, natural look. The most popular Pro Lash shape.",
      svgPattern: "varied",
      tips: [
        { icon: "feather", title: "Soft, Feathery, Natural", text: "Wispy mimics real lash variation. The finished look reads as effortless — yours, just better." },
        { icon: "camera", title: "Photographs Beautifully", text: "Wispy lashes catch light at different angles. They photograph beautifully." }
      ]
    },
    even: {
      label: "Even & Full Across", icon: "shapeEven", vibe: "polished and uniform",
      desc: "Even lashes create a clean, polished look with consistent fullness across the lash line. Classic Hollywood glamour.",
      svgPattern: "uniform",
      tips: [
        { icon: "ruler", title: "Same Length, End to End", text: "Even styles look best with consistent length across your lash line for that polished, uniform finish." },
        { icon: "eye", title: "Check Both Eyes Together", text: "Finish one eye, then compare to the other. Even styles make any asymmetry stand out." },
        { icon: "sparkles", title: "The 'Doll Eye' Effect", text: "Even lashes open up your eyes for that wide-awake, doll-like look." }
      ]
    },
    "cat-eye": {
      label: "Longer Outer Corner", icon: "shapeCatEye", vibe: "lifted and elongated",
      desc: "The cat-eye shape lengthens toward the outer corner for a natural lift. The most universally flattering shape.",
      svgPattern: "cat-eye",
      tips: [
        { icon: "arrowUp", title: "Graduate the Length", text: "Start with shorter segments at the inner corner and longer toward the outer for a smooth, lifted line." },
        { icon: "target", title: "Anchor the Outer Corner", text: "Place your longest segment at the very outer corner. That single segment creates most of the cat-eye lift." }
      ]
    }
  },

  products: {
    "10day": {
      short: {
        wispy: [
          { name: "Classic Shorties No. 05", type: "ProWear \xb7 10-Day Wear", price: "$70.00", match: "98%", primary: true, why: "Short, wispy segments with varied lengths for that effortlessly natural, feathered look. The 'your lashes but better' effect." },
          { name: "Classic No. 01", type: "ProWear \xb7 10-Day Wear", price: "$70.00", match: "91%", primary: false, why: "Clean, classic short segments. A touch more uniform but still beautifully subtle." }
        ],
        even: [
          { name: "Classic Shorties No. 05", type: "ProWear \xb7 10-Day Wear", price: "$70.00", match: "96%", primary: true, why: "Even distribution of short segments for a clean, polished look. Subtle but defined." },
          { name: "Classic No. 01", type: "ProWear \xb7 10-Day Wear", price: "$70.00", match: "93%", primary: false, why: "Consistent short lengths across your lash line for uniform, put-together definition." }
        ],
        "cat-eye": [
          { name: "Classic Shorties No. 05", type: "ProWear \xb7 10-Day Wear", price: "$70.00", match: "95%", primary: true, why: "Short lengths with subtle graduated increase toward the outer corner. A hint of cat-eye lift." },
          { name: "Classic Luxe Wispy No. 15", type: "ProWear \xb7 10-Day Wear", price: "$70.00", match: "88%", primary: false, why: "Slightly longer with outer corner emphasis. If the Shorties feel too subtle, this adds more shape." }
        ]
      },
      medium: {
        wispy: [
          { name: "Classic Luxe Wispy No. 15", type: "ProWear \xb7 10-Day Wear", price: "$70.00", match: "99%", primary: true, why: "The Allure award winner. Medium-length wispy segments with perfect feathered texture. The most popular Pro Lash style." },
          { name: "Classic No. 01", type: "ProWear \xb7 10-Day Wear", price: "$70.00", match: "92%", primary: false, why: "Medium classic segments for a slightly more uniform take on wispy. A great daily driver." }
        ],
        even: [
          { name: "Classic No. 01", type: "ProWear \xb7 10-Day Wear", price: "$70.00", match: "97%", primary: true, why: "The definitive medium-length, even-distribution style. Consistent density for that polished, editorial look." },
          { name: "Volume No. 02", type: "ProWear \xb7 10-Day Wear", price: "$70.00", match: "90%", primary: false, why: "Same even distribution with more density per segment. Adds fullness while keeping the even shape." }
        ],
        "cat-eye": [
          { name: "Classic Luxe Wispy No. 15", type: "ProWear \xb7 10-Day Wear", price: "$70.00", match: "96%", primary: true, why: "Medium lengths with natural outer-corner graduation. Wispy texture plus cat-eye shape is the most universally flattering combo." },
          { name: "Classic No. 01", type: "ProWear \xb7 10-Day Wear", price: "$70.00", match: "89%", primary: false, why: "Clean medium segments you can customize for cat-eye placement. Place the longest at the outer third." }
        ]
      },
      long: {
        wispy: [
          { name: "Volume No. 02", type: "ProWear \xb7 10-Day Wear", price: "$70.00", match: "97%", primary: true, why: "Long, wispy volume segments that create dimension and movement. Statement lashes that still look natural." },
          { name: "Volume Luxe XL No. 12", type: "ProWear \xb7 10-Day Wear", price: "$70.00", match: "89%", primary: false, why: "Extra-long wispy segments for maximum feathered drama. Takes the texture to its fullest expression." }
        ],
        even: [
          { name: "Volume No. 02", type: "ProWear \xb7 10-Day Wear", price: "$70.00", match: "96%", primary: true, why: "Long, even volume across your entire lash line. Full, lush, and consistent." },
          { name: "Classic No. 01", type: "ProWear \xb7 10-Day Wear", price: "$70.00", match: "85%", primary: false, why: "A more refined long look with classic density. Less volume but more polished." }
        ],
        "cat-eye": [
          { name: "Volume No. 02", type: "ProWear \xb7 10-Day Wear", price: "$70.00", match: "98%", primary: true, why: "Long volume segments with dramatic outer-corner graduation. Magnetic, lifted, and absolutely striking." },
          { name: "Volume Shorties No. 06", type: "ProWear \xb7 10-Day Wear", price: "$70.00", match: "87%", primary: false, why: "Shorter volume segments for the inner/center, pair with No. 02 at the outer for a custom graduated cat-eye." }
        ]
      },
      "extra-long": {
        wispy: [
          { name: "Volume Luxe XL No. 12", type: "ProWear \xb7 10-Day Wear", price: "$70.00", match: "98%", primary: true, why: "Maximum length, maximum feathered texture. The lashes that make people stop and ask 'what are you wearing?'" },
          { name: "Mega No. 03", type: "ProWear \xb7 10-Day Wear", price: "$70.00", match: "91%", primary: false, why: "Even more volume than the XL. If you want your lashes to be THE thing people notice, Mega delivers." }
        ],
        even: [
          { name: "Mega No. 03", type: "ProWear \xb7 10-Day Wear", price: "$70.00", match: "97%", primary: true, why: "Full, even, maximum-volume drama. Every lash at maximum intensity. The red carpet, main character style." },
          { name: "Volume Luxe XL No. 12", type: "ProWear \xb7 10-Day Wear", price: "$70.00", match: "92%", primary: false, why: "Slightly less dense than Mega but still extra-long. The length with a bit more breathing room." }
        ],
        "cat-eye": [
          { name: "Volume Luxe XL No. 12", type: "ProWear \xb7 10-Day Wear", price: "$70.00", match: "97%", primary: true, why: "Extra-long segments with maximum outer-corner drama. The most dramatic cat-eye in the lineup." },
          { name: "Mega No. 03", type: "ProWear \xb7 10-Day Wear", price: "$70.00", match: "90%", primary: false, why: "The ultimate in volume and length. Pair with XL placement strategy for a cat-eye that rivals pro extensions." }
        ]
      }
    },
    "5day": {
      short: {
        wispy: [ { name: "Original Shorties", type: "Essentials \xb7 Complete Kit \xb7 5-Day Wear", price: "$35.00", match: "97%", primary: true, why: "Short, wispy segments for a subtle, natural feathered look. Perfect for testing the waters." }, { name: "Original", type: "Essentials \xb7 Complete Kit \xb7 5-Day Wear", price: "$35.00", match: "90%", primary: false, why: "Classic short segments with a natural finish. Clean and simple." } ],
        even: [ { name: "Original Shorties", type: "Essentials \xb7 Complete Kit \xb7 5-Day Wear", price: "$35.00", match: "95%", primary: true, why: "Even, short segments for a polished, barely-there look." }, { name: "Original", type: "Essentials \xb7 Complete Kit \xb7 5-Day Wear", price: "$35.00", match: "91%", primary: false, why: "Uniform short segments for a clean, defined look." } ],
        "cat-eye": [ { name: "Original Shorties", type: "Essentials \xb7 Complete Kit \xb7 5-Day Wear", price: "$35.00", match: "94%", primary: true, why: "Short segments with subtle outer-corner graduation. A whisper of cat-eye lift." }, { name: "Original", type: "Essentials \xb7 Complete Kit \xb7 5-Day Wear", price: "$35.00", match: "88%", primary: false, why: "Short segments that you can customize for a gentle cat-eye effect." } ]
      },
      medium: {
        wispy: [ { name: "Wispy", type: "Essentials \xb7 Complete Kit \xb7 5-Day Wear", price: "$35.00", match: "98%", primary: true, why: "Medium wispy segments designed for textured, feathered movement. The most popular Essentials style." }, { name: "Original", type: "Essentials \xb7 Complete Kit \xb7 5-Day Wear", price: "$35.00", match: "89%", primary: false, why: "Medium segments with a classic finish. Less textured but naturally beautiful." } ],
        even: [ { name: "Original", type: "Essentials \xb7 Complete Kit \xb7 5-Day Wear", price: "$35.00", match: "97%", primary: true, why: "Clean, balanced medium segments for an effortless natural look. The everyday Essentials." }, { name: "Full", type: "Essentials \xb7 Complete Kit \xb7 5-Day Wear", price: "$35.00", match: "90%", primary: false, why: "Medium-length, full-density segments for polished, even coverage." } ],
        "cat-eye": [ { name: "Wispy", type: "Essentials \xb7 Complete Kit \xb7 5-Day Wear", price: "$35.00", match: "96%", primary: true, why: "Medium wispy segments that naturally create a cat-eye effect with outer-corner placement." }, { name: "Full", type: "Essentials \xb7 Complete Kit \xb7 5-Day Wear", price: "$35.00", match: "87%", primary: false, why: "Full medium segments for a bolder cat-eye. More density at the outer corner." } ]
      },
      long: {
        wispy: [ { name: "Wispy", type: "Essentials \xb7 Complete Kit \xb7 5-Day Wear", price: "$35.00", match: "95%", primary: true, why: "Wispy segments that deliver length and texture. Beautiful feathered dimension." }, { name: "Full", type: "Essentials \xb7 Complete Kit \xb7 5-Day Wear", price: "$35.00", match: "88%", primary: false, why: "Full-density segments for a voluminous, long look." } ],
        even: [ { name: "Full", type: "Essentials \xb7 Complete Kit \xb7 5-Day Wear", price: "$35.00", match: "96%", primary: true, why: "Long, full, even coverage for maximum impact." }, { name: "Max", type: "Essentials \xb7 Complete Kit \xb7 5-Day Wear", price: "$35.00", match: "89%", primary: false, why: "Maximum density for the boldest even look." } ],
        "cat-eye": [ { name: "Full", type: "Essentials \xb7 Complete Kit \xb7 5-Day Wear", price: "$35.00", match: "95%", primary: true, why: "Long full segments with cat-eye placement. Dramatic outer-corner lift." }, { name: "Max", type: "Essentials \xb7 Complete Kit \xb7 5-Day Wear", price: "$35.00", match: "87%", primary: false, why: "Maximum density with cat-eye graduation. The boldest 5-day look." } ]
      },
      "extra-long": {
        wispy: [ { name: "Max", type: "Essentials \xb7 Complete Kit \xb7 5-Day Wear", price: "$35.00", match: "96%", primary: true, why: "Maximum length and volume with wispy texture. Full-drama for a shorter commitment." }, { name: "Full", type: "Essentials \xb7 Complete Kit \xb7 5-Day Wear", price: "$35.00", match: "88%", primary: false, why: "Long, full segments as a slightly more polished alternative to Max." } ],
        even: [ { name: "Max", type: "Essentials \xb7 Complete Kit \xb7 5-Day Wear", price: "$35.00", match: "97%", primary: true, why: "Maximum everything. Full, even, extra-long coverage. Go big for 5 days." }, { name: "Full", type: "Essentials \xb7 Complete Kit \xb7 5-Day Wear", price: "$35.00", match: "90%", primary: false, why: "A step down from Max in density but still extra-long." } ],
        "cat-eye": [ { name: "Max", type: "Essentials \xb7 Complete Kit \xb7 5-Day Wear", price: "$35.00", match: "95%", primary: true, why: "Extra-long max-volume with dramatic cat-eye placement. The most dramatic 5-day look." }, { name: "Full", type: "Essentials \xb7 Complete Kit \xb7 5-Day Wear", price: "$35.00", match: "87%", primary: false, why: "Long, full segments for a bold cat-eye lift." } ]
      }
    }
  },

  reviews: {
    wispy: [
      { text: "The wispy texture is EVERYTHING. It looks like I was born with perfect lashes. So many compliments.", author: "Taylor R.", detail: "Wispy \xb7 Classic Luxe Wispy No. 15", stars: 5 },
      { text: "I wanted feathery and natural. Got exactly that. The varied lengths create such beautiful dimension.", author: "Morgan K.", detail: "Wispy \xb7 Original Shorties", stars: 5 },
      { text: "Best wispy lashes I've ever tried. They move so naturally and the texture is unreal.", author: "Jasmine W.", detail: "Wispy \xb7 Volume No. 02", stars: 5 }
    ],
    even: [
      { text: "So clean and polished. Every lash perfectly in place. I look put-together even on my laziest days.", author: "Brittany M.", detail: "Even & full \xb7 Classic No. 01", stars: 5 },
      { text: "The even distribution gives me that perfect doll-eye look. My eyes have never looked more open.", author: "Samantha L.", detail: "Even & full \xb7 Full", stars: 5 },
      { text: "I love the consistency. No gaps, no weird spots. Just perfect, uniform lashes all the way across.", author: "Christina H.", detail: "Even & full \xb7 Volume No. 02", stars: 5 }
    ],
    "cat-eye": [
      { text: "The cat-eye lift is incredible. My eyes look so lifted and elongated. I get asked if I've had work done!", author: "Megan D.", detail: "Cat-eye \xb7 Classic Luxe Wispy No. 15", stars: 5 },
      { text: "Outer corner emphasis is my favorite shape. These create the perfect lifted effect without eyeliner.", author: "Ashley P.", detail: "Cat-eye \xb7 Volume No. 02", stars: 5 },
      { text: "I've been chasing this cat-eye look for years with strips. Pro Lash nailed it in one application.", author: "Nicole F.", detail: "Cat-eye \xb7 Original", stars: 5 }
    ]
  }
};

// ══════════════════════════════════════
// QUIZ WIZARD
// ══════════════════════════════════════

const QUIZ_STEPS = [
  {
    input: 'qExperience', param: 'exp',
    title: `Have you worn <em>lashes</em> before?`,
    sub: `No wrong answers. This helps us pick styles you'll nail on day one.`,
    opts: [
      { v: 'never', icon: 'sparkles', label: 'Never tried', sub: 'First time, made easy' },
      { v: 'mascara', icon: 'mascaraBottle', label: 'Mascara only', sub: 'Ready for the upgrade' },
      { v: 'strips', icon: 'stripLash', label: 'Strip lashes', sub: 'You know the drill' },
      { v: 'extensions', icon: 'tweezers', label: 'Pro extensions', sub: 'Salon look, your schedule' }
    ]
  },
  {
    input: 'qWearTime', param: 'wear',
    title: `How long do you want <em>them to last?</em>`,
    sub: `Both apply in minutes. The difference is the bond.`,
    opts: [
      { v: '10day', icon: 'calendar10', label: '10+ days', sub: 'ProWear. Our strongest bond.' },
      { v: '5day', icon: 'calendar5', label: 'Up to 5 days', sub: 'Essentials. Easy on, easy off.' }
    ]
  },
  {
    input: 'qLength', param: 'length',
    title: `How much <em>length?</em>`,
    sub: `Think about your everyday, not just special occasions.`,
    opts: [
      { v: 'short', icon: 'lashHairShort', label: 'Short', sub: 'Subtle, everyday' },
      { v: 'medium', icon: 'lashHairMedium', label: 'Medium', sub: 'Polished, put-together' },
      { v: 'long', icon: 'lashHairLong', label: 'Long', sub: 'Defined, confident' },
      { v: 'extra-long', icon: 'lashHairXL', label: 'Extra long', sub: 'Full drama' }
    ]
  },
  {
    input: 'qShape', param: 'shape',
    title: `Pick your <em>shape.</em>`,
    sub: `This decides how your lash line flows.`,
    opts: [
      { v: 'wispy', icon: 'shapeWispy', label: 'Wispy & feathered', sub: 'Soft, textured, natural' },
      { v: 'even', icon: 'shapeEven', label: 'Even & full', sub: 'Clean, uniform, polished' },
      { v: 'cat-eye', icon: 'shapeCatEye', label: 'Cat-eye lift', sub: 'Longer toward the outer corner' }
    ]
  },
  {
    type: 'name', param: 'name',
    title: `Almost done. <em>Where do we send it?</em>`,
    sub: `Your matches plus a 10% code, straight to your inbox.`
  }
];

let quizIndex = 0;
let quizStartFired = false;

function renderQuiz() {
  const host = document.getElementById('quizStepsHost');
  host.innerHTML = QUIZ_STEPS.map((s, i) => {
    if (s.type === 'name') {
      return `<div class="quiz-step" data-step="${i}">
        <div class="quiz-question">${s.title}</div>
        <div class="quiz-sub">${s.sub}</div>
        <div class="quiz-name-wrap">
          <input type="text" class="quiz-name-input" id="quizNameInput" placeholder="first name (or we call you babe)" autocomplete="given-name" maxlength="30">
          <input type="email" class="quiz-name-input quiz-email-input" id="quizEmailInput" placeholder="your@email.com" autocomplete="email" inputmode="email">
          <button type="button" class="btn btn-full" onclick="finishQuiz(true)">GET MY RESULTS + 10% OFF</button>
          <button type="button" class="quiz-skip" onclick="finishQuiz(false)">Skip, just show my results</button>
        </div>
      </div>`;
    }
    return `<div class="quiz-step" data-step="${i}">
      <div class="quiz-question">${s.title}</div>
      <div class="quiz-sub">${s.sub}</div>
      <div class="quiz-opts ${s.opts.length === 2 ? 'single-col' : ''}">
        ${s.opts.map(o => `<button type="button" class="quiz-opt" data-input="${s.input}" data-value="${o.v}" onclick="pickOption(this)">
          <span class="quiz-opt-icon">${ICONS[o.icon]}</span>
          <span><h4>${o.label}</h4><p>${o.sub}</p></span>
        </button>`).join('')}
      </div>
    </div>`;
  }).join('');
  showQuizStep(0);
  track('quiz_view');
  document.getElementById('quizBack').addEventListener('click', () => {
    if (quizIndex > 0) { track('quiz_back', { from_step: quizIndex + 1 }); showQuizStep(quizIndex - 1); }
  });
}

function showQuizStep(i) {
  quizIndex = i;
  document.querySelectorAll('.quiz-step').forEach(el => el.classList.remove('active'));
  document.querySelector(`.quiz-step[data-step="${i}"]`).classList.add('active');
  document.getElementById('quizProgressBar').style.width = `${((i + 1) / QUIZ_STEPS.length) * 100}%`;
  document.getElementById('quizStepCount').textContent = `${i + 1} OF ${QUIZ_STEPS.length}`;
  document.getElementById('quizBack').style.visibility = i === 0 ? 'hidden' : 'visible';
  if (QUIZ_STEPS[i].type === 'name') {
    setTimeout(() => { const inp = document.getElementById('quizNameInput'); if (inp) inp.focus(); }, 350);
  }
  window.scrollTo({ top: 0, behavior: 'smooth' });
}

function pickOption(btn) {
  document.getElementById(btn.dataset.input).value = btn.dataset.value;
  btn.parentNode.querySelectorAll('.quiz-opt').forEach(b => b.classList.remove('selected'));
  btn.classList.add('selected');
  if (!quizStartFired) { track('quiz_start'); quizStartFired = true; }
  const step = QUIZ_STEPS[quizIndex];
  track('quiz_step_complete', { step_number: quizIndex + 1, question: step.param, answer: btn.dataset.value });
  setTimeout(() => showQuizStep(quizIndex + 1), 220);
}

function finishQuiz(withEmail) {
  const nameInput = document.getElementById('quizNameInput');
  document.getElementById('qName').value = (nameInput.value || '').trim();
  const qs = new URLSearchParams();
  if (document.getElementById('qName').value) qs.set('name', document.getElementById('qName').value);
  qs.set('exp', document.getElementById('qExperience').value);
  qs.set('wear', document.getElementById('qWearTime').value);
  qs.set('length', document.getElementById('qLength').value);
  qs.set('shape', document.getElementById('qShape').value);
  try { history.replaceState(null, '', window.location.pathname + '?' + qs.toString()); } catch (e) {}
  if (withEmail) {
    const emInput = document.getElementById('quizEmailInput');
    const em = (emInput.value || '').trim();
    if (!em || em.indexOf('@') === -1 || em.indexOf('.') === -1) {
      emInput.style.borderColor = '#b3261e';
      emInput.focus();
      return;
    }
    window.__emailCaptured = true;
    __shouldFireConfetti = true;
    track('quiz_email_submit', { source: 'inline' });
    subscribeEmail(em).catch(() => {});
  } else {
    track('quiz_email_skip');
  }
  generatePage();
}

// ══════════════════════════════════════
// RENDER
// ══════════════════════════════════════

function generateShapeSVG(shape, length) {
  const lm = { short: 0.7, medium: 1, long: 1.25, 'extra-long': 1.5 }[length] || 1;
  const cx=180,cy=80,ew=280,eh=60,n=10;
  let s='';
  s+=`<ellipse cx="${cx}" cy="${cy}" rx="${ew/2}" ry="${eh/2}" fill="none" stroke="${getComputedStyle(document.documentElement).getPropertyValue('--taupe').trim()}" stroke-width="1.5" opacity="0.4"/>`;
  s+=`<circle cx="${cx}" cy="${cy}" r="18" fill="none" stroke="#000" stroke-width="0.8" opacity="0.2"/>`;
  s+=`<circle cx="${cx}" cy="${cy}" r="7" fill="#000" opacity="0.15"/>`;
  for(let i=0;i<n;i++){const t=i/(n-1),a=Math.PI+t*Math.PI,x=cx+(ew/2-10)*Math.cos(a),by=cy+(eh/2-2)*Math.sin(a);let sl;if(shape==='wispy')sl=(7+Math.sin(i*2.3)*3+Math.cos(i*1.7)*2)*lm;else if(shape==='even')sl=8.5*lm;else sl=(5+t*7)*lm;const la=-Math.PI/2+(t-0.5)*0.5,ex=x+Math.cos(la)*sl*2,ey=by+Math.sin(la)*sl*2;const ik=(shape==='cat-eye'&&t>0.6)||(shape==='even')||(shape==='wispy'&&sl>8*lm);s+=`<line x1="${x}" y1="${by}" x2="${ex}" y2="${ey}" stroke="${ik?'#000':'#bbb'}" stroke-width="${ik?2.5:1.5}" stroke-linecap="round"/>`}
  s+=`<text x="55" y="145" font-family="Avenir Next,sans-serif" font-size="9" fill="#7a7a7a" text-anchor="middle" font-weight="700" letter-spacing="1">INNER</text>`;
  s+=`<text x="${cx}" y="145" font-family="Avenir Next,sans-serif" font-size="9" fill="#7a7a7a" text-anchor="middle" font-weight="700" letter-spacing="1">CENTER</text>`;
  s+=`<text x="305" y="145" font-family="Avenir Next,sans-serif" font-size="9" fill="#7a7a7a" text-anchor="middle" font-weight="700" letter-spacing="1">OUTER</text>`;
  return s;
}

function generatePage() {
  const name=document.getElementById('qName').value.trim()||'Babe';
  const experience=document.getElementById('qExperience').value;
  const wearTime=document.getElementById('qWearTime').value;
  const length=document.getElementById('qLength').value;
  const shape=document.getElementById('qShape').value;
  const exp=DATA.experience[experience], wear=DATA.wearTime[wearTime], len=DATA.lengths[length], shp=DATA.shapes[shape];
  const products=DATA.products[wearTime][length][shape], reviews=DATA.reviews[shape];

  window.__quizState = { name, experience, wearTime, length, shape, topMatch: products[0].name };

  track('quiz_complete', { experience: experience, wear_time: wearTime, length: length, shape: shape, top_match: products[0].name, persona: detectPersona(window.__quizState) });

  document.getElementById('loader').classList.add('active');
  setTimeout(()=>{
    document.body.classList.add('results-ready');
    const isEssentials = wearTime === '5day';
    document.body.classList.toggle('essentials-results', isEssentials);
    if (isEssentials) {
      const variantColor = ESSENTIALS_VARIANT_COLORS[products[0].name] || '#6E1532';
      document.body.style.setProperty('--essentials-accent', variantColor);
    } else {
      document.body.style.removeProperty('--essentials-accent');
    }

    document.getElementById('heroBadge').innerHTML=`<span class="hero-badge-prefix">You chose</span><span class="hero-badge-divider">\xb7</span>${wear.tag} \xb7 ${len.label.toUpperCase()} \xb7 ${shp.label.toUpperCase()}`;
    document.getElementById('heroTitle').innerHTML=`${name}, meet your<br><em>perfect lash match.</em>`;
    document.getElementById('heroSubtitle').textContent=exp.heroNudge;

    document.getElementById('productsTitle').innerHTML=`Your <em>top matches.</em>`;
    document.getElementById('productsSubtitle').textContent=`${len.label} length, ${shp.label.toLowerCase()} shape, ${wear.label.toLowerCase()}.`;

    const kit = KITS[wearTime];
    const topName = products[0].name;
    const kitVariant = kit.variants[topName];
    document.getElementById('kitFeature').innerHTML = `
      <div class="kit-feature-img"><img src="${sized(kit.img, 900)}" alt="${kit.title}"></div>
      <div class="kit-feature-body">
        <span class="kit-feature-badge">YOUR COMPLETE KIT</span>
        <div class="kit-feature-name">${kit.title}</div>
        <div class="kit-feature-style">WITH <span class="kit-feature-style-name">${topName}</span> \xb7 YOUR #1 MATCH</div>
        <p class="kit-feature-blurb">${kit.blurb}</p>
        <div class="kit-includes">${wear.kitItems.map(i=>`<span class="kit-include">${ICONS[i.icon]}${i.name}</span>`).join('')}</div>
        <div class="kit-feature-price">${kit.price}</div>
        <div class="kit-feature-value">${kit.valueLine}</div>
        <button class="btn" onclick="addToCart(${kitVariant})">CLAIM MY KIT \u2014 ${kit.price}</button>
      </div>`;

    document.getElementById('altMatchesLabel').textContent = wearTime==='10day' ? 'OR JUST THE LASHES' : 'YOUR STYLE MATCHES';
    document.getElementById('productGrid').innerHTML=products.map(p=>{
      const img=PRODUCT_IMAGES[p.name]||'';
      const vid = VARIANT_IDS[p.name] || '';
      return`<div class="product-card ${p.primary?'primary':''}"><div class="product-img-wrap">${p.primary?'<span class="product-badge">YOUR #1 MATCH</span>':''}${img?`<img src="${sized(img, 640)}" alt="${p.name}" class="product-img" loading="lazy">`:`<div style="font-family:var(--heading);font-size:14px;color:var(--text-light);font-style:italic">${p.name}</div>`}</div><div class="product-info"><div class="product-match">${p.match} MATCH</div><div class="product-name">${p.name}</div><div class="product-type">${p.type}</div><div class="product-why">${p.why}</div><div class="product-price">${p.price}</div><button class="btn btn-full" onclick="addToCart(${vid})">CLAIM THIS LASH \u2014 ${p.price}</button></div></div>`}).join('');

    document.getElementById('profileTitle').textContent=`${name}'s Lash Profile`;
    document.getElementById('matchTags').innerHTML=[
      {icon:exp.icon,label:exp.label},{icon:wear.icon,label:wear.label},{icon:len.icon,label:len.label+' Length'},{icon:shp.icon,label:shp.label}
    ].map(t=>`<div class="match-tag">${ICONS[t.icon]}${t.label}</div>`).join('');
    document.getElementById('matchSummary').textContent=exp.summary;

    document.getElementById('whySection').innerHTML=`<section class="section fade-in"><div class="section-label">WHY THIS WORKS FOR YOU</div><div class="section-title">Picked for <em>${exp.label.toLowerCase()}s.</em></div><div class="why-grid">${exp.whyCards.map(c=>`<div class="why-card"><div class="why-card-icon">${ICONS[c.icon]}</div><h3>${c.title}</h3><p>${c.text.replace('{daysLine}', wear.daysLine)}</p></div>`).join('')}</div></section>`;

    document.getElementById('kitLabel').textContent=`WHAT'S IN YOUR ${wear.tag} KIT`;
    document.getElementById('kitTitle').innerHTML=`Your complete <em>lash routine, sorted.</em>`;
    document.getElementById('kitSubtitle').textContent=wear.description;
    document.getElementById('kitGrid').innerHTML=wear.kitItems.map(i=>`<div class="kit-item"><div class="kit-item-icon">${ICONS[i.icon]}</div><h4>${i.name}</h4><p>${i.desc}</p></div>`).join('');

    document.getElementById('shapeTitle').textContent=shp.label;
    const vibeArticle=/^[aeiou]/i.test(shp.vibe)?'an':'a';
    document.getElementById('shapeSubtitle').textContent=`${len.label} length with ${vibeArticle} ${shp.vibe} finish.`;
    document.getElementById('shapeDiagramTitle').textContent=`${shp.label} \xb7 ${len.label} Length`;
    const curveImg = LASH_CURVES[products[0].name];
    if (curveImg) {
      document.getElementById('shapeSVG').style.display='none';
      let curveEl = document.getElementById('shapeCurveImg');
      if (!curveEl) { curveEl = document.createElement('img'); curveEl.id='shapeCurveImg'; document.getElementById('shapeSVG').parentNode.insertBefore(curveEl, document.getElementById('shapeSVG')); }
      curveEl.src = sized(curveImg, 800);
      curveEl.alt = `${products[0].name} lash curve`;
      curveEl.loading = 'lazy';
      curveEl.style.display = 'block';
    } else {
      document.getElementById('shapeSVG').style.display='block';
      let curveEl = document.getElementById('shapeCurveImg');
      if (curveEl) curveEl.style.display='none';
      document.getElementById('shapeSVG').innerHTML=generateShapeSVG(shape,length);
    }
    document.getElementById('shapeDesc').textContent=shp.desc;
    document.getElementById('shapeTips').innerHTML=shp.tips.map(t=>`<div class="shape-tip"><div class="shape-tip-icon">${ICONS[t.icon]}</div><div><h4>${t.title}</h4><p>${t.text}</p></div></div>`).join('');

    document.getElementById('stepsLabel').textContent=experience==='never'?'YOUR FIRST APPLICATION':'HOW TO APPLY';
    document.getElementById('stepsTitle').innerHTML=`Ready in minutes. <em>Every time.</em>`;
    document.getElementById('stepsGrid').innerHTML=exp.steps.map((s,i)=>`<div class="step-card"><div class="step-image">${STEP_IMAGES[i]?`<img src="${sized(STEP_IMAGES[i], 800)}" alt="Step ${i+1}: ${s.title}" loading="lazy">`:''}</div><div class="step-number">${i+1}</div><h3>${s.title}</h3><p>${s.text.replace('{daysLine}', wear.daysLine)}</p></div>`).join('');
    document.getElementById('stepsCallout').innerHTML=exp.callout;

    document.getElementById('reviewsLabel').textContent=`FROM ${shp.label.toUpperCase()} LOVERS`;
    document.getElementById('reviewsTitle').innerHTML=`Real results, <em>${shp.vibe}.</em>`;
    document.getElementById('reviewGrid').innerHTML=reviews.map(r=>`<div class="review-card"><div class="review-stars">${'★'.repeat(r.stars)}</div><div class="review-text">"${r.text}"</div><div class="review-author">${r.author}</div><div class="review-detail">${r.detail}</div></div>`).join('');

    renderEmailSpots();

    let sticky = document.getElementById('stickyCta');
    if (!sticky) { sticky = document.createElement('div'); sticky.id = 'stickyCta'; sticky.className = 'sticky-cta'; document.body.appendChild(sticky); }
    sticky.innerHTML = `<div class="sticky-cta-info"><div class="sticky-cta-name">${kit.title}</div><div class="sticky-cta-price">${kit.price} \xb7 with ${topName}</div></div><button class="btn" onclick="addToCart(${kitVariant})">CLAIM \u2014 ${kit.price}</button>`;

    document.getElementById('loader').classList.remove('active');
    setTimeout(()=>{document.querySelectorAll('.fade-in').forEach((el,i)=>{setTimeout(()=>el.classList.add('visible'),i*80)})},100);
    window.scrollTo({ top: 0 });

    if (__shouldFireConfetti) {
      __shouldFireConfetti = false;
      setTimeout(() => fireConfetti(), 350);
    }
  },800);
}

// ══════════════════════════════════════
// CONFETTI (email-capture celebration)
// ══════════════════════════════════════

let __shouldFireConfetti = false;

function fireConfetti() {
  const colors = ['#6E1532', '#E5AACD', '#5D88BC', '#E7D770', '#CF282B', '#AE987C'];
  const container = document.createElement('div');
  container.className = 'confetti-container';
  document.body.appendChild(container);
  for (let i = 0; i < 60; i++) {
    const piece = document.createElement('div');
    piece.className = 'confetti-piece';
    piece.style.left = Math.random() * 100 + 'vw';
    piece.style.background = colors[Math.floor(Math.random() * colors.length)];
    piece.style.animationDelay = Math.random() * 0.4 + 's';
    piece.style.animationDuration = (2 + Math.random() * 1.4) + 's';
    piece.style.transform = `rotate(${Math.random() * 360}deg)`;
    container.appendChild(piece);
  }
  setTimeout(() => container.remove(), 4200);
}

// ══════════════════════════════════════
// KLAVIYO EMAIL CAPTURE
// ══════════════════════════════════════

// Read config injected by the Shopify section, fall back to defaults for standalone use
const KLAVIYO_COMPANY_ID = (window.LASH_MATCH_CONFIG || {}).klaviyoCompanyId || 'VBemGA';
const KLAVIYO_LIST_ID = (window.LASH_MATCH_CONFIG || {}).klaviyoListId || 'Sj8cpF';
const DISCOUNT_CODE = (window.LASH_MATCH_CONFIG || {}).discountCode || 'MYLASH10';

function track(name, params) {
  try {
    var payload = Object.assign({ event_category: 'lash_quiz' }, params || {});
    if (typeof window.gtag === 'function') { window.gtag('event', name, payload); return; }
    if (window.dataLayer) window.dataLayer.push(Object.assign({ event: name }, payload));
  } catch (e) {}
}
window.LashMatchTrack = track;

function detectPersona(s) {
  if (s.topMatch === 'Original') return 'serena-stan';
  if (s.experience === 'extensions') return 'salon-escapee';
  if (s.experience === 'never' || s.experience === 'mascara') return 'lash-newbie';
  if (s.wearTime === '5day') return 'essentials-buyer';
  if ((s.length === 'short' || s.length === 'medium') && s.shape !== 'cat-eye') return 'natural-beauty-seeker';
  return null;
}

function sized(src, w) { return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }

const PRODUCT_LINKS = {
  "Classic No. 01": "https://prolash.com/products/classic-lashes",
  "Classic Shorties No. 05": "https://prolash.com/products/classic-lashes-shorties",
  "Classic Luxe Wispy No. 15": "https://prolash.com/products/classic-luxe-wispy-no-15",
  "Volume No. 02": "https://prolash.com/products/volume-lashes",
  "Volume Shorties No. 06": "https://prolash.com/products/volume-shorty",
  "Volume Luxe XL No. 12": "https://prolash.com/products/volume-luxe-xl",
  "Mega No. 03": "https://prolash.com/products/mega-volume-lashes",
  "Original": "https://prolash.com/products/essentials-complete-kit?variant=47861615493364",
  "Original Shorties": "https://prolash.com/products/essentials-complete-kit?variant=47861615460596",
  "Wispy": "https://prolash.com/products/essentials-complete-kit?variant=47861615526132",
  "Full": "https://prolash.com/products/essentials-complete-kit?variant=47861615591668",
  "Max": "https://prolash.com/products/essentials-complete-kit?variant=47861615558900",
};

function kitLink(wearTime, kitVariant) {
  return wearTime === '10day'
    ? 'https://prolash.com/products/starter-kit-1?variant=' + kitVariant
    : 'https://prolash.com/products/essentials-complete-kit?variant=' + kitVariant;
}

function withDiscount(url) {
  const path = url.replace('https://prolash.com', '');
  return 'https://prolash.com/discount/' + DISCOUNT_CODE + '?redirect=' + encodeURIComponent(path);
}

function getAnswers() {
  const wearTime = document.getElementById('qWearTime').value;
  const length = document.getElementById('qLength').value;
  const shape = document.getElementById('qShape').value;
  return {
    name: document.getElementById('qName').value.trim() || 'Babe',
    experience: document.getElementById('qExperience').value,
    wearTime: wearTime, length: length, shape: shape,
    topMatch: DATA.products[wearTime][length][shape][0].name
  };
}

function subscribeEmail(email) {
  const s = getAnswers();
  const persona = detectPersona(s);
  const profileAttrs = {
    email: email,
    properties: {
      quiz_experience: s.experience,
      quiz_wear_time: s.wearTime,
      quiz_length: s.length,
      quiz_shape: s.shape,
      quiz_top_match: s.topMatch,
      quiz_persona: persona,
      quiz_source: 'Lash Match Quiz'
    }
  };
  if (s.name && s.name !== 'Babe') profileAttrs.first_name = s.name;
  const matches = DATA.products[s.wearTime][s.length][s.shape];
  const kit = KITS[s.wearTime];
  const kitVariant = kit.variants[s.topMatch];
  const productsAll = [{
    id: String(kitVariant),
    title: kit.title + ' with ' + s.topMatch,
    image: sized(kit.img, 1024),
    link: withDiscount(kitLink(s.wearTime, kitVariant)),
    price: parseFloat(kit.price.replace('$', '')),
    price_formatted: kit.price
  }].concat(matches.map(function(p) {
    return {
      id: String(VARIANT_IDS[p.name] || ''),
      title: p.name,
      image: sized(PRODUCT_IMAGES[p.name] || kit.img, 1024),
      link: withDiscount(PRODUCT_LINKS[p.name] || 'https://prolash.com/pages/lash-match'),
      price: parseFloat(p.price.replace('$', '')),
      price_formatted: p.price
    };
  }));
  const resultsUrl = window.location.search.indexOf('sub=1') > -1
    ? window.location.href
    : window.location.href + (window.location.search ? '&' : '?') + 'sub=1';
  fetch('https://a.klaviyo.com/client/events/?company_id=' + KLAVIYO_COMPANY_ID, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'revision': '2025-01-15' },
    body: JSON.stringify({
      data: {
        type: 'event',
        attributes: {
          properties: {
            quiz_experience: s.experience,
            quiz_wear_time: s.wearTime,
            quiz_length: s.length,
            quiz_shape: s.shape,
            quiz_top_match: s.topMatch,
            quiz_persona: persona,
            first_name: s.name,
            discount_code: DISCOUNT_CODE,
            results_url: resultsUrl,
            products_all: productsAll,
            recommended_product_titles: productsAll.map(function(p) { return p.title; })
          },
          metric: { data: { type: 'metric', attributes: { name: 'Filled Out Lash Match Quiz' } } },
          profile: { data: { type: 'profile', attributes: profileAttrs } }
        }
      }
    })
  }).catch(() => {});
  return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_COMPANY_ID, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'revision': '2025-01-15' },
    body: JSON.stringify({
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Lash Match Quiz',
          profile: { data: { type: 'profile', attributes: profileAttrs } }
        },
        relationships: { list: { data: { type: 'list', id: KLAVIYO_LIST_ID } } }
      }
    })
  }).then(r => { if (!(r.ok || r.status === 202)) throw new Error('subscribe failed'); });
}

function copyCode(el) {
  navigator.clipboard.writeText(DISCOUNT_CODE);
  el.textContent = 'COPIED!';
  setTimeout(() => { el.textContent = DISCOUNT_CODE; }, 2000);
}

function bindEmailForm(formId, inputId, errId, btnLabel) {
  const f = document.getElementById(formId);
  if (!f) return;
  f.addEventListener('submit', function(e) {
    e.preventDefault();
    const email = document.getElementById(inputId).value.trim();
    if (!email) return;
    const btn = f.querySelector('button');
    btn.disabled = true; btn.textContent = 'SENDING...';
    subscribeEmail(email).then(() => {
      window.__emailCaptured = true;
      track('quiz_email_submit', { source: formId === 'unlockForm' ? 'results_unlock' : 'results_bottom' });
      fireConfetti();
      renderEmailSpots();
    }).catch(() => {
      btn.disabled = false; btn.textContent = btnLabel;
      const err = document.getElementById(errId);
      err.textContent = 'Something hiccuped. Try again?';
      err.style.display = 'block';
    });
  });
}

function renderEmailSpots() {
  const s = getAnswers();
  const unlock = document.getElementById('unlockSection');
  const bottom = document.getElementById('emailSection');
  if (window.__emailCaptured) {
    unlock.innerHTML = `<p>Here's <strong>10% off</strong>, ${s.name}. Your code:</p>
      <div class="discount-code" onclick="copyCode(this)">${DISCOUNT_CODE}</div>
      <div class="discount-note">Tap to copy. Your matches are in your inbox too.</div>`;
    bottom.innerHTML = `<div class="section-label">YOUR CODE</div>
      <div class="email-title">You're <em>in.</em></div>
      <p class="email-sub">${DISCOUNT_CODE} gets you 10% off your first order. It's in your inbox too.</p>
      <div class="discount-code" onclick="copyCode(this)" style="background:rgba(255,255,255,0.1);border-color:var(--taupe);color:var(--white)">${DISCOUNT_CODE}</div>`;
  } else {
    unlock.innerHTML = `<p><strong>10% off</strong> your match, ${s.name}. Where do we send your code?</p>
      <form class="email-form" id="unlockForm">
        <input type="email" class="email-input email-input-light" id="unlockEmail" placeholder="your@email.com" required inputmode="email">
        <button type="submit" class="btn">UNLOCK 10% OFF</button>
      </form>
      <div class="email-error" id="unlockError" style="display:none"></div>`;
    bottom.innerHTML = `<div class="section-label">SAVE YOUR RESULTS</div>
      <div class="email-title">${s.name === 'Babe' ? 'Keep your <em>match.</em>' : s.name + ', keep your <em>match.</em>'}</div>
      <p class="email-sub">We'll send your matches and your 10% code straight to your inbox.</p>
      <form class="email-form" id="emailFormBottom">
        <input type="email" class="email-input" id="emailInputBottom" placeholder="your@email.com" required inputmode="email">
        <button type="submit" class="btn btn-white">EMAIL MY RESULTS</button>
      </form>
      <div class="email-error" id="emailErrorBottom" style="display:none"></div>`;
    bindEmailForm('unlockForm', 'unlockEmail', 'unlockError', 'UNLOCK 10% OFF');
    bindEmailForm('emailFormBottom', 'emailInputBottom', 'emailErrorBottom', 'EMAIL MY RESULTS');
  }
}

// ══════════════════════════════════════
// INIT
// ══════════════════════════════════════

window.addEventListener('DOMContentLoaded', function() {
  var params = new URLSearchParams(window.location.search);
  var hasAnswers = params.get('exp') || params.get('wear') || params.get('length') || params.get('shape');
  function setSel(id, val, allowed) { if (val && allowed.indexOf(val) !== -1) document.getElementById(id).value = val; }
  if (hasAnswers) {
    if (params.get('sub')) window.__emailCaptured = true;
    document.getElementById('qName').value = params.get('name') || '';
    setSel('qExperience', params.get('exp'), ['never','mascara','strips','extensions']);
    setSel('qWearTime', params.get('wear'), ['10day','5day']);
    setSel('qLength', params.get('length'), ['short','medium','long','extra-long']);
    setSel('qShape', params.get('shape'), ['wispy','even','cat-eye']);
    generatePage();
  } else {
    renderQuiz();
  }
});
